// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__15luj","content":"styles_content__3-1yr","tableWrap":"styles_tableWrap__29lmc"};